import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  markerTemplates: [],
  loading: false,
  error: null,
  successMessage: null,
};

const markerTemplateSlice = createSlice({
  name: "markerTemplate",
  initialState,
  reducers: {
    setMarkerTemplates: (state, action) => {
      state.markerTemplates = action.payload;
      state.loading = false;
      state.error = null;
      state.successMessage = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.successMessage = null;
      state.loading = false;
    },
    setSuccess: (state, action) => {
      state.successMessage = action.payload;
      state.error = null;
      state.loading = false;
    },
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
});

export const { setMarkerTemplates, setLoading, setError, setSuccess, clearMessages } = markerTemplateSlice.actions;
export default markerTemplateSlice.reducer;
